import { Grid2 as Grid } from '@mui/material';
import { AccordionForm, AccordionFormPanelProps as Props } from '@react-admin/ra-form-layout';
import { BooleanInput, required, SelectInput } from 'react-admin';
import { ReactElement } from 'react';
import TzDateTimeInput from '../../../Components/TzDate/TzDateTimeInput';
import { BID_TYPE, BID_TYPE_CHOICES } from '../utils';

export default function BidStatusSection(props: Omit<Props, 'children'>): ReactElement {
  return (
    <AccordionForm.Panel {...props}>
      <Grid container spacing={2} size={{ xs: 12 }}>
        <SelectInput
          choices={BID_TYPE_CHOICES}
          defaultValue={BID_TYPE.CATEGORY}
          label="Bid Type"
          source="attributes.bid_type"
          validate={[required()]}
        />
        <BooleanInput label="Active?" source="attributes.active" defaultValue />
        <TzDateTimeInput label="Starts At" source="attributes.starts_at" />
        <TzDateTimeInput label="Ends At" source="attributes.ends_at" />
      </Grid>
    </AccordionForm.Panel>
  );
}
